module.exports = __webpack_public_path__ + "img/0-06.aad3a3ab.jpg";